import React, { useState, useMemo } from 'react';
import { plusIcon, searchIcon } from '../../utils/images';
import { MediaLibraryCard } from '../MediaLibraryCard';
import { Pagination } from '../Pagination';
import { MediaLibraryTabs } from '../MediaLibraryTabs';
import './MediaLibraryList.scss';
import { useMediaLibrary } from '../../contexts/MediaLibraryContext';

interface MediaImage {
  name: string;
  url: string;
  last_modified: string;
}

interface MediaLibraryResponse {
  bucket_name: string;
  limit: number;
  offset: number;
  images: MediaImage[];
}

interface MediaLibraryListProps {
  mediaLibraryData: MediaLibraryResponse;
  loading?: boolean;
  onUpload?: () => void;
}

export const MediaLibraryList: React.FC<MediaLibraryListProps> = ({ 
  mediaLibraryData, 
  loading,
  onUpload
}) => {
  const [searchQuery, setSearchQuery] = useState<string>('');
  const { currentPage, totalPages, goToPage, activeTab, setActiveTab, loading: contextLoading } = useMediaLibrary();

  const filteredMediaLibraries = useMemo(() => {
    return mediaLibraryData.images.filter((mediaImage: MediaImage) => {
      const query = searchQuery.toLowerCase();
      const nameMatch = mediaImage.name.toLowerCase().includes(query);
      return nameMatch;
    });
  }, [mediaLibraryData.images, searchQuery]);

  return (
    <>
      <div className="media-library-list">
        <div className="media-library-list__title">
          <label className="media-library-list__label">
          <p className="media-library-list__label--text">Media Library</p>
          </label>
          <button className="media-library-list__add-button" onClick={onUpload}>
            <img 
              className="media-library-list__add-button-icon media-library-list__add-button-icon--left"
              src={plusIcon} 
              alt='plus icon'
            />
            <span className="media-library-list__add-button-text">Add Media</span>
          </button>
        </div>

        <MediaLibraryTabs 
          activeTab={activeTab}
          onTabChange={setActiveTab}
          disabled={contextLoading}
        />

        <div className="media-library-list__actions">
          <div className="media-library-list__filters">
            <div className="media-library-list__search">
              <img className="media-library-list__search--icon" src={searchIcon} alt='search icon'/>
              <input 
                type="text" 
                className="media-library-list__search--input" 
                placeholder="Search by name" 
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>
          </div>
        </div>

        <div className="media-library-list__list">
          {filteredMediaLibraries.length > 0 ? (
              filteredMediaLibraries.map((mediaImage, index) => (
                <MediaLibraryCard 
                  key={`${mediaImage.name}-${index}`} 
                  mediaImage={mediaImage} 
                />
              ))
          ) : (
            <p className="media-library-list__no-results">No media found.</p>
          )}
        </div>

        <Pagination 
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={goToPage}
          disabled={loading}
        />
      </div>
    </>
  );
}; 